import { jsx } from 'react/jsx-runtime';
import React__default, { useContext } from 'react';

var blockContextInitialValue = {
  renderScopedBlock: function renderScopedBlock() {
    return null;
  }
};
var ScopedBlockitRendererContext = /*#__PURE__*/React__default.createContext(blockContextInitialValue);
var ScopedBlockitRendererContextProvider = function ScopedBlockitRendererContextProvider(_ref) {
  var children = _ref.children,
    _renderScopedBlock = _ref.renderScopedBlock;
  var parentContextValues = useContext(ScopedBlockitRendererContext);
  var renderScopedBlock = React__default.useCallback(function (block) {
    var renderers = [_renderScopedBlock, parentContextValues === null || parentContextValues === void 0 ? void 0 : parentContextValues.renderScopedBlock];
    for (var _i = 0, _renderers = renderers; _i < _renderers.length; _i++) {
      var renderer = _renderers[_i];
      var result = renderer === null || renderer === void 0 ? void 0 : renderer(block);
      if (result) return result;
    }
    return null;
  }, [parentContextValues, _renderScopedBlock]);
  return jsx(ScopedBlockitRendererContext.Provider, {
    value: {
      renderScopedBlock: renderScopedBlock
    },
    children: children
  });
};

export { ScopedBlockitRendererContext, ScopedBlockitRendererContextProvider };
